import { Component, computed, inject, input } from "@angular/core";
import { useTranslationNamespace } from "@logex/framework/lg-localization";
import {
    DefinitionTag,
    SharedDefinitions
} from "@mrdm-self-service-frontend/shared/data-access-definitions";

@Component({
    selector: "app-tag-summary",
    templateUrl: "./tag-summary.component.html",
    styleUrls: ["./tag-summary.component.scss"],
    providers: [useTranslationNamespace("APP._Shared.TagSummary")],
    standalone: false
})
export class TagSummaryComponent {
    private _definitions = inject(SharedDefinitions);

    readonly maxCount = input(0);
    readonly tagCodes = input<string[]>();

    readonly tags = computed(() =>
        (this.tagCodes() ?? [])
            .map(code => this._definitions.tag[code])
            .filter((tag): tag is DefinitionTag => !!tag)
    );

    readonly totalTags = computed(() => this.tags().length);

    readonly visibleTagCount = computed(() => {
        const maxCount = this.maxCount();
        const totalTags = this.totalTags();

        if (maxCount === totalTags) {
            return totalTags;
        }

        if (maxCount <= 0) {
            return 0;
        }

        return maxCount - 1;
    });

    readonly visibleTags = computed(() => this.tags().slice(0, this.visibleTagCount()));
    readonly hiddenTags = computed(() => this.tags().slice(this.visibleTagCount()));
    readonly hiddenTagCount = computed(() => this.hiddenTags().length);
    readonly showTagCount = computed(() => this.maxCount() === 0);
    readonly showMore = computed(() => this.maxCount() !== 0 && this.hiddenTagCount() > 0);
    readonly tooltipTags = computed(() => (this.showTagCount() ? this.tags() : this.hiddenTags()));
}
